package net.lateinit.bug_or_feature.site.styles

import org.jetbrains.compose.web.css.*

object GlobalKeyframes : StyleSheet("") {
    val voteSuccess by keyframes {
        from {
            property("opacity", "0")
            property("transform", "scale(0.95)")
        }
        to {
            property("opacity", "1")
            property("transform", "scale(1)")
        }
    }

    val checkmark by keyframes {
        from {
            property("transform", "scale(0) rotate(0deg)")
            property("opacity", "0")
        }
        50.percent {
            property("transform", "scale(1.3) rotate(180deg)")
            property("opacity", "1")
        }
        to {
            property("transform", "scale(1) rotate(360deg)")
            property("opacity", "1")
        }
    }

    val barGrow by keyframes {
        from { property("width", "0") }
    }

    val toastSlideIn by keyframes {
        from {
            property("transform", "translateX(400px)")
            property("opacity", "0")
        }
        to {
            property("transform", "translateX(0)")
            property("opacity", "1")
        }
    }

    val fadeIn by keyframes {
        from { property("opacity", "0") }
        to { property("opacity", "1") }
    }

    val dialogSlideIn by keyframes {
        from {
            property("opacity", "0")
            property("transform", "scale(0.95) translateY(-10px)")
        }
        to {
            property("opacity", "1")
            property("transform", "scale(1) translateY(0)")
        }
    }
}
